import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import socketIOClient from 'socket.io-client';

import { MESSAGE, SOCKET_SERVER_URL, TIME_WAIT } from './config';
import type { StatusType } from './config';
interface callData {
    callerData: Object,
    receiverId: string,
    ojectId: string
}
export const SocketContext = React.createContext({});

export const useSocket = (props: any) => {
    const dispatch = useDispatch();
    const socketRef = useRef(null);
    const [ usersStatus, setUsersStatus ] = useState();
    const [ groups, setGroups ] = useState();

    const sendUserStatus = (userId: string, status: StatusType) => {
        if (!socketRef.current) {
            // console.log("send user status no socket: "+ status);

            return;
        }

        // console.log("send user status: "+ status);
        socketRef.current.emit(MESSAGE.SEND_STATUS, { userId,
            status });
    };

    const socketInit = (user: any) => {
        socketRef.current = socketIOClient(SOCKET_SERVER_URL, {
            query: { roomId: user.createdBy ?? user.id,
                userId: user.id }
        });
    };

    const onStatus = () => {
        socketRef.current.on(MESSAGE.SEND_ROOM, room => {
            setUsersStatus(room?.users);
            setGroups(room?.groups);
        });
    };

    const onCall = user => {
        socketRef.current.on(
            MESSAGE.CALL_USER,
            (data: callData) => {
                if (user) {
                    if (data.callerData.userId === user.id) {
                        // dispatch({
                        //     type: 'SET_CALLING_INFO',
                        //     info: data
                        // });
                    } else if (data.receiverId === user.id) {
                        // set info of call and open Call Reminder pop-up
                        dispatch({
                            type: 'SET_CALLING_INFO',
                            info: data
                        });
                        dispatch({
                            type: 'SET_CALLING_DIALOG',
                            show: true
                        });

                        // after 1 minutes, close Call Reminder pop-up
                        setTimeout(() => {
                            dispatch({
                                type: 'SET_CALLING_DIALOG',
                                show: false
                            });
                        }, TIME_WAIT);
                    }
                }
            }
        );
    };

    const onScheduleCall = user => {
        socketRef.current.on(
            MESSAGE.MEETING_SCHEDULE,
            data => {
                if (user) {
                    if (user.id === data.meetingSchedule.meetingOwner
                        || data.meetingSchedule.participants.find(p => p.user.id === user.id)) {
                        // set info of call and open Schedule Call pop-up
                        dispatch({
                            type: 'SET_SCHEDULE_CALL_INFO',
                            info: data
                        });

                        dispatch({
                            type: 'SET_SCHEDULE_CALL_DIALOG',
                            show: true
                        });
                    }
                }
            }
        );
    };

    const onLeaveCall = user => {
        socketRef.current.on(
            MESSAGE.LEAVE_CALL,
            (data: any) => {
                if (user) {
                    if (data.userId !== user.id) {
                        // do some thing
                    }
                }
            }
        );
    };

    const createGroup = data => {
        if (!socketRef.current) {
            return;
        }
        socketRef.current.emit(MESSAGE.CREATE_GROUP, data);
    };

    const editGroup = (data, user) => {
        if (!socketRef.current) {
            socketInit(user);
        }
        socketRef.current.emit(MESSAGE.EDIT_GROUP, data);
    };

    const removeGroup = (data, user) => {
        if (!socketRef.current) {
            socketInit(user);
        }
        socketRef.current.emit(MESSAGE.REMOVE_GROUP, data);
    };

    return {
        socket: socketRef.current,
        socketInit,
        sendUserStatus,
        onCall,
        onScheduleCall,
        onLeaveCall,
        onStatus,
        usersStatus,
        groups,
        createGroup,
        editGroup,
        removeGroup
    };
};
